module.exports = __webpack_public_path__ + "img/imq4.e07b77be.png";